
import {
  IonContent,
  IonText,
  IonTab,
  IonChip,
  IonAvatar,
} from '@modus/ionic-vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Home',
  components: {
    IonContent,
    IonText,
    IonTab,
    IonChip,
    IonAvatar,
  },
})
